import React from 'react'
import type { ButtonProps } from '@vtex/admin-ui'
import { Button, IconTrash, csx } from '@vtex/admin-ui'

export type RemoveItemButtonProps = ButtonProps

export const RemoveItemButton = (props: RemoveItemButtonProps) => (
  <Button
    size="large"
    variant="tertiary"
    className={csx({
      width: '60px',
      marginRight: '$space-4',
      borderRadius: 4,
      padding: '$space-3',
      border: '$neutral',
    })}
    data-testid="remove-item-button"
    icon={
      <IconTrash
        color="black"
        className={csx({
          ':hover': { color: '$action.main.secondaryHover' },
        })}
      />
    }
    {...props}
  />
)
